import Vue from "vue"
import LoadScript from "vue-plugin-load-script"
import { VueQueryPlugin } from "@tanstack/vue-query"

import "@/styles/tailwind.sass"
import "@/styles/element/index.css"

import ElementUI, { Message } from "element-ui"

import App from "@/App.vue"
import router, { addWildcardRoute } from "@/routers"
import store from "@/store"

import { UtilityApi } from "@vitable/asclepius-api-client-ts"
import locale from "element-ui/lib/locale/lang/en"
import { DateTime, Settings } from "luxon"
import sentryService from "@/services/sentry-service"

// --- import modules -----
import { registerModule } from "@/module-register"
import { medicationModule } from "@/modules/medication"
import { taskModule } from "@/modules/tasks"
import { timezoneModule } from "@/modules/timezone"
import { appointmentModule } from "@/modules/appointments"
import { chartingModule } from "@/modules/charting"
import { deprecatedChartingModule } from "@/modules/charting-deprecated"
import { occupationalHealthModule } from "@/modules/occupational-health"
import { schedulingModule } from "@/modules/scheduling"
import { providersModule } from "@/modules/providers"
import { authModule } from "@/modules/auth"
import { asyncVisitModule } from "@/modules/async-appointment"

// ---- 401 interceptors -----
new UtilityApi().axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      store.dispatch("me/logout")
    }
    return Promise.reject(error)
  }
)

Vue.use(VueQueryPlugin)
Vue.use(LoadScript)
Vue.use(ElementUI, { locale })
Vue.prototype.$luxon = DateTime
Vue.prototype.$luxonSettings = Settings
Vue.prototype.$message = (options) => Message({ duration: 6000, showClose: true, ...options })

sentryService.init()

const app = new Vue({
  router,
  store,
  render: (h) => h(App)
})

// registerModule(app, chatModule)
registerModule(app, authModule)
registerModule(app, occupationalHealthModule)
registerModule(app, medicationModule)
registerModule(app, taskModule)
registerModule(app, timezoneModule)
registerModule(app, appointmentModule)
registerModule(app, chartingModule)
registerModule(app, deprecatedChartingModule)
registerModule(app, schedulingModule)
registerModule(app, providersModule)
registerModule(app, asyncVisitModule)

addWildcardRoute()

store.dispatch("me/init")
app.$mount("#app")
